import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import colorModel from './colorModel.vue';
import { mapMutations } from 'vuex';
export default {
  components: {
    colorModel
  },
  props: {
    configureList: {
      type: Array,
      default() {
        return [];
      }
    },
    styleObj: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      oldForm: {},
      form: {
        topNavigation: [],
        policySearch: {
          searchTerms: [],
          buttonInfo: {
            buttonDisplay: false,
            buttons: [
            //按钮配置
            {
              buttonName: '查看详情',
              //按钮文案
              buttonFontColor: '#fff',
              //按钮文字颜色
              buttonBgColor: '#FF6B00',
              //按钮颜色
              buttonDisplayStatus: [1, 2, 3, 6],
              //按钮可展示的状态 保单状态 0待投保 1待生效 2保障中 3已过期 4退保中 5已退保 6退保失败
              mark: 1,
              //??
              buttonPopUp: false,
              //是否弹窗
              controlsJump: undefined,
              buttonPopUpConfig: {
                //此处为弹框示例不一定会用到
                // popUpPosition: 'central', //弹窗位置:中部central、底部bottom
                // popUpTitle: '', //弹窗标题
                // popUpContent: '' //弹窗内容
                // buttonInfo: [
                //   //按钮配置
                //   {
                //     buttonName: '我要投保', //按钮文案
                //     buttonFontColor: '#fff', //按钮文字颜色
                //     buttonEvent: 'close' //按钮事件:关闭弹窗close、跳转页面jump
                //   }
                // ]
              }
            }, {
              buttonName: '查看电子保单',
              buttonFontColor: '#FF6B00',
              buttonBgColor: '#fff',
              buttonDisplayStatus: [1, 2, 3, 4, 6],
              //按钮可展示的状态 保单状态 0待投保 1待生效 2保障中 3已过期 4退保中 5已退保 6退保失败
              mark: 1,
              buttonPopUp: false,
              buttonPopUpConfig: {}
            }, {
              buttonName: '开具发票',
              buttonFontColor: '#FF6B00',
              buttonBgColor: '#fff',
              buttonDisplayStatus: [1, 2, 3, 6],
              //按钮可展示的状态 保单状态 0待投保 1待生效 2保障中 3已过期 4退保中 5已退保 6退保失败 发票状态：未开票、开票失败；是否可开具发票：可开具发票；
              mark: 1,
              buttonPopUp: false,
              buttonPopUpConfig: {}
            }, {
              buttonName: '查看发票',
              buttonFontColor: '#FF6B00',
              buttonBgColor: '#fff',
              buttonDisplayStatus: [1, 2, 3, 6],
              //按钮可展示的状态 保单状态 0待投保 1待生效 2保障中 3已过期 4退保中 5已退保 6退保失败 发票状态：已开票；
              mark: 1,
              buttonPopUp: false,
              buttonPopUpConfig: {}
            }]
          },
          invoiceInfo: {
            buttonDisplay: false,
            buttons: [{
              buttonName: '开具发票',
              buttonFontColor: '#fff',
              buttonBgColor: '#FF6B00',
              mark: 1,
              buttonPopUp: false,
              buttonPopUpConfig: {},
              idVerity: true //身份验证
            }]
          }
        },
        orderSearch: {
          searchTerms: [],
          buttonInfo: {
            buttonDisplay: false,
            buttons: [
            //按钮配置
            {
              buttonName: '继续支付',
              //按钮文案
              buttonFontColor: '#fff',
              //按钮文字颜色
              buttonBgColor: '#FF6B00',
              //按钮颜色
              buttonDisplayStatus: [4, 5],
              //按钮可展示的状态 订单支付状态 1已支付 2已退款 3部分退款 4待支付 5取消支付 6退款失败 7已失效(支付时间已失效需重新发起支付或重新下单)
              mark: 1,
              //??
              buttonPopUp: false,
              //是否弹窗
              buttonPopUpConfig: {}
            }, {
              buttonName: '再次投保',
              buttonFontColor: '#FF6B00',
              buttonBgColor: '#fff',
              buttonDisplayStatus: [7],
              //按钮可展示的状态 订单支付状态 1已支付 2已退款 3部分退款 4待支付 5取消支付 6退款失败 7已失效(支付时间已失效需重新发起支付或重新下单)
              mark: 1,
              buttonPopUp: false,
              buttonPopUpConfig: {}
            }]
          }
        }
      },
      colorShow: false,
      navCheckedList: [],
      //选中的导航
      chooseNav: [],
      //选中的导航,用来判断是不是只选中了一个
      policySearchCheckedList: [],
      //保单查询条件选中的
      choosePolicySearch: [],
      //保单查询条件选中的,用来判断是不是只选中了一个
      orderSearchCheckedList: [],
      //订单查询条件选中的
      chooseOrderSearch: [],
      //订单查询条件选中的,用来判断是不是只选中了一个
      itemType: '',
      //保单查询还是订单查询
      btnIdx: '' //按钮下标
    };
  },
  mounted() {
    console.log('=========================Mounted=========================');
    this.$nextTick(() => {
      var _this$form, _this$form2;
      this.form = this.styleObj;
      if (!sessionStorage.getItem('oldForm')) {
        this.oldForm = JSON.parse(JSON.stringify(this.styleObj));
        sessionStorage.setItem('oldForm', JSON.stringify(this.oldForm));
      }

      // 导航
      this.navCheckedList = this.form.topNavigation.map(item => {
        if (item.navigationDisplay) {
          return item.navigationLabel;
        }
      });
      this.chooseNav = this.navCheckedList;
      // 保单搜索条件
      console.log(this.form, this.oldForm, 'this.form');
      this.policySearchCheckedList = (_this$form = this.form) === null || _this$form === void 0 || (_this$form = _this$form.policySearch) === null || _this$form === void 0 ? void 0 : _this$form.searchTerms.map(item => {
        if (item.termDisplay) {
          return item.termValue;
        }
      });
      this.choosePolicySearch = this.policySearchCheckedList;
      // 订单搜索条件
      this.orderSearchCheckedList = (_this$form2 = this.form) === null || _this$form2 === void 0 || (_this$form2 = _this$form2.orderSearch) === null || _this$form2 === void 0 ? void 0 : _this$form2.searchTerms.map(item => {
        if (item.termDisplay) {
          return item.termValue;
        }
      });
      this.chooseOrderSearch = this.orderSearchCheckedList;
    });
  },
  computed: {
    queryInfoActiveTab: {
      get() {
        console.log('========================= configure queryInfoActiveTab get =========================');
        return this.$store.state.control.queryInfoActiveTab;
      },
      set(val) {
        console.log('========================= configure queryInfoActiveTab set =========================');
        console.log(val, 'val');
        this.$store.commit('control/SET_QUERY_INFO_ACTIVE_TAB', val);
      }
    }
  },
  methods: {
    ...mapMutations({
      SET_QUERY_INFO_ACTIVE_TAB: 'control/SET_QUERY_INFO_ACTIVE_TAB'
    }),
    // 身份校验
    idVerityChange(val) {
      console.log('=========================idVerityChange=========================');
      console.log(val, 'val');
      this.queryInfoActiveTab = 'policy';
      this.form.policySearch.invoiceInfo.buttons[0].idVerity = val;
    },
    // 发票配置
    invoiceBtnChangeFun(type, e) {
      console.log('=========================invoiceBtnChangeFun=========================');
      this.oldForm = JSON.parse(sessionStorage.getItem('oldForm'));
      this.queryInfoActiveTab = type;
      if (type == 'policy') {
        this.form.policySearch.invoiceInfo.buttonDisplay = e.target.checked;
        if (!this.form.policySearch.invoiceInfo.buttonDisplay) {
          this.form.policySearch.invoiceInfo.buttons = JSON.parse(JSON.stringify(this.oldForm.policySearch.invoiceInfo.buttons));
        }
      }
    },
    cardBtnChangeFun(type, e) {
      console.log('=========================cardBtnChangeFun=========================');
      this.oldForm = JSON.parse(sessionStorage.getItem('oldForm'));
      this.queryInfoActiveTab = type;
      if (type == 'policy') {
        this.form.policySearch.buttonInfo.buttonDisplay = e.target.checked;
        if (!this.form.policySearch.buttonInfo.buttonDisplay) {
          this.form.policySearch.buttonInfo.buttons = JSON.parse(JSON.stringify(this.oldForm.policySearch.buttonInfo.buttons));
        }
      }
      if (type == 'order') {
        this.form.orderSearch.buttonInfo.buttonDisplay = e.target.checked;
        if (!this.form.orderSearch.buttonInfo.buttonDisplay) {
          this.form.orderSearch.buttonInfo.buttons = JSON.parse(JSON.stringify(this.oldForm.orderSearch.buttonInfo.buttons));
        }
      }
    },
    // 导航切换事件
    checkboxChange() {
      this.oldForm = JSON.parse(sessionStorage.getItem('oldForm'));
      console.log('==================== checkboxChange ====================');
      console.log('this.navCheckedList', this.navCheckedList);
      if (this.navCheckedList.length != 0) {
        this.chooseNav = this.navCheckedList;
        this.form.topNavigation.forEach(item => {
          if (this.chooseNav.includes(item.navigationLabel)) {
            item.navigationDisplay = true;
          } else {
            item.navigationDisplay = false;
          }
        });
        // 重置数据
        if (!this.navCheckedList.includes('保单查询')) {
          var _this$form3;
          this.form.policySearch.searchTerms = JSON.parse(JSON.stringify(this.oldForm.policySearch.searchTerms));
          this.form.policySearch.buttonInfo = JSON.parse(JSON.stringify(this.oldForm.policySearch.buttonInfo));
          this.form.policySearch.invoiceInfo = JSON.parse(JSON.stringify(this.oldForm.policySearch.invoiceInfo));
          // 保单搜索条件
          this.policySearchCheckedList = (_this$form3 = this.form) === null || _this$form3 === void 0 || (_this$form3 = _this$form3.policySearch) === null || _this$form3 === void 0 ? void 0 : _this$form3.searchTerms.map(item => {
            if (item.termDisplay) {
              return item.termValue;
            }
          });
          this.choosePolicySearch = this.policySearchCheckedList;
        } else if (!this.navCheckedList.includes('订单查询')) {
          var _this$oldForm;
          this.form.orderSearch.searchTerms = JSON.parse(JSON.stringify(this.oldForm.orderSearch.searchTerms));
          this.form.orderSearch.buttonInfo = JSON.parse(JSON.stringify(this.oldForm.orderSearch.buttonInfo));
          // 订单搜索条件
          this.orderSearchCheckedList = (_this$oldForm = this.oldForm) === null || _this$oldForm === void 0 || (_this$oldForm = _this$oldForm.orderSearch) === null || _this$oldForm === void 0 ? void 0 : _this$oldForm.searchTerms.map(item => {
            if (item.termDisplay) {
              return item.termValue;
            }
          });
          this.chooseOrderSearch = this.orderSearchCheckedList;
        }
      } else {
        this.$message.warning(this.$t('保单查询、订单查询不能同时取消勾选'));
        this.navCheckedList = this.chooseNav;
      }
    },
    // 查询条件切换事件
    searchCheckboxChange(type) {
      console.log('==================== searchCheckboxChange ====================');
      console.log('type', type);
      this.queryInfoActiveTab = type;
      if (type == 'policy') {
        if (this.policySearchCheckedList.length != 0) {
          this.choosePolicySearch = this.policySearchCheckedList;
          this.form.policySearch.searchTerms.forEach(item => {
            if (this.choosePolicySearch.includes(item.termValue)) {
              item.termDisplay = true;
            } else {
              item.termDisplay = false;
            }
          });
        } else {
          this.$message.warning(this.$t('保单查询') + this.$t('条件') + this.$t('不能同时取消勾选'));
          this.policySearchCheckedList = this.choosePolicySearch;
        }
      } else if (type == 'order') {
        if (this.orderSearchCheckedList.length != 0) {
          this.chooseOrderSearch = this.orderSearchCheckedList;
          this.form.orderSearch.searchTerms.forEach(item => {
            if (this.chooseOrderSearch.includes(item.termValue)) {
              item.termDisplay = true;
            } else {
              item.termDisplay = false;
            }
          });
        } else {
          this.$message.warning(this.$t('订单查询') + this.$t('条件') + this.$t('不能同时取消勾选'));
          this.orderSearchCheckedList = this.chooseOrderSearch;
        }
      }
    },
    changeFun() {
      console.log('==================== changeFun ====================');
      this.$emit('itemChange', this.form);
    },
    colorClickFun(type, idx, val, key) {
      this.colorShow = true;
      this.itemType = type;
      this.btnIdx = idx;
      this.$nextTick(() => {
        this.$refs.colorRef.init(val, key);
      });
    },
    colorFun(val, key) {
      console.log(val, key, this.itemType, this.btnIdx, 'val, key');
      if (this.itemType == 'policySearch') {
        this.queryInfoActiveTab = 'policy';
        this.form[this.itemType].buttonInfo.buttons[this.btnIdx][key] = val;
      } else if (this.itemType == 'orderSearch') {
        this.queryInfoActiveTab = 'order';
        this.form[this.itemType].buttonInfo.buttons[this.btnIdx][key] = val;
      } else if (this.itemType == 'invoiceInfo') {
        this.queryInfoActiveTab = 'policy';
        this.form.policySearch[this.itemType].buttons[this.btnIdx][key] = val;
      }
      this.changeFun();
      this.colorShow = false;
    }
  }
};